import { render, staticRenderFns } from "./InquiryInformation.vue?vue&type=template&id=c23c32dc&scoped=true&"
import script from "./InquiryInformation.vue?vue&type=script&lang=js&"
export * from "./InquiryInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23c32dc",
  null
  
)

export default component.exports